<template>
  <div class="detail-wrap">
    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}SLA规则
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button v-if="slaSave" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 工单来源 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>创建工单</b> -->
            </div>
            <table class="table-detail">
              <tbody>
<!--              <tr>-->
<!--                <th>-->
<!--                  <em class="f-red">*</em>-->
<!--                  消息类型-->
<!--                </th>-->
<!--                <td colspan="3" class="table-row">-->
<!--                <div class="table-cell">-->
<!--                  <el-select v-model="tenant.messageType" style="width: 8vw;">-->
<!--                    <el-option label="工单" :value="1" />-->
<!--                    <el-option label="备件申请" :value="2" />-->
<!--                    <el-option label="结算" :value="3" />-->
<!--                    <el-option label="考核" :value="4" />-->
<!--                  </el-select>-->
<!--                </div>-->
<!--                </td>-->
<!--              </tr>-->
              <tr>
                <th>
                  <em class="f-red">*</em>
                  SLA名称
                </th>
                <td colspan="3" class="table-row">
                  <div class="table-cell">
                    <el-input type="text" autocomplete="off" v-model="tenant.slaName" clearable/>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  标准时效
                </th>
                <td colspan="5" class="table-row">
                  <div class="table-cell">
                    <el-select v-model="tenant.firstTime" style="width: 8vw;">
                      <el-option v-for="item in timeTypeList" :key="item.type" :label="item.name"
                                 :value="item.type">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="table-cell">
                    在
                  </div>
                  <div class="table-cell">
                    <el-select v-model="tenant.secondTime" style="width: 8vw;">
                      <el-option v-for="item in timeTypeList" :key="item.type" :label="item.name"
                                 :value="item.type">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="table-cell">
                    之后
                  </div>
                  <div class="table-cell">
                    <el-input type="text" style="width: 2vw;" autocomplete="off" v-model="tenant.achieveValue" clearable/>
                  </div>
                  <div class="table-cell">
                    <el-select v-model="tenant.achieveValueUnit" style="width: 8vw;">
                      <el-option label="分钟" :value="1" />
                      <el-option label="小时" :value="2" />
                      <el-option label="工作日" :value="3" />
                    </el-select>
                  </div>
                  <div class="table-cell">
                    完成
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  提醒时间
                </th>
                <td colspan="5" class="table-row">
                  <div class="table-cell">
                    在标准时效到达前
                  </div>
                  <div class="table-cell">
                    <el-input type="text" style="width: 2vw;" autocomplete="off" v-model="tenant.wareingValue" clearable/>
                  </div>
                  <div class="table-cell">
                    <el-select v-model="tenant.wareingValueUnit" style="width: 8vw;">
                      <el-option label="分钟" :value="1" />
                      <el-option label="小时" :value="2" />
                      <el-option label="工作日" :value="3" />
                    </el-select>
                  </div>
                  <div class="table-cell">
                    进行通知
                  </div>
                </td>
              </tr>
<tr>
  <th>考核科目</th>
  <td colspan="5" class="table-row">
    <checkSubjectSearch :check-subject-id.sync="tenant.checkSubjectId"
                        :check-subject-name.sync="tenant.checkSubjectName" />
  </td>
</tr>

              <tr>
                <th>
                  匹配服务类型
                </th>
                <td colspan="5" class="table-row">
                  <div class="table-cell">
                    <el-input type="text" autocomplete="off" v-model="tenant.serviceTypeNames" clearable>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="selectServiceType"></i>
                    </el-input>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  匹配工单来源
                </th>
                <td colspan="5" class="table-row">
                  <div class="table-cell">
                    <el-input type="text" autocomplete="off" v-model="tenant.orderTypeNames" clearable>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="selectOrderType"></i>
                    </el-input>
                  </div>
                </td>
              </tr>
<!--              <tr v-if="dataId">-->
<!--                <th>-->
<!--                  <em class="f-red"></em>-->
<!--                  创建人-->
<!--                </th>-->
<!--                <td colspan="5" class="table-row">-->
<!--                  <div class="table-cell">-->
<!--                  {{ tenant.createBy }}-->
<!--                  </div>-->
<!--                </td>-->
<!--                <th>-->
<!--                  <em class="f-red"></em>-->
<!--                  创建时间-->
<!--                </th>-->
<!--                <td colspan="5" class="table-row">-->
<!--                  <div class="table-cell">-->
<!--                  {{ tenant.createTime }}-->
<!--                  </div>-->
<!--                </td>-->
<!--              </tr>-->
              </tbody>
            </table>
          </div>
          <div>
          </div>
        </div>
      </div>
    </el-form>
    <orderTypeDialog v-if="showOrderTypeDialog" @commitSelectedRow="commitSelectedRow"
                        :visiable.sync="showOrderTypeDialog" multi="true" :param="orderTypeDialogParam"/>
    <serviceTypeDialog v-if="showServiceTypeDialog" @commitSelectedRowService="commitSelectedRowService"
                     :visiable.sync="showServiceTypeDialog" multi="true" :param="serviceDialogParam"/>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import request from "@/router/axios";
import orderTypeDialog from "@/views/dialogCommon/orderTypeDialog.vue";
import serviceTypeDialog from "@/views/dialogCommon/serviceTypeDialog.vue";
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {dictType, loadDictData} from "@/config/dictType";
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {
    orderTypeDialog,
    serviceTypeDialog,
    checkSubjectSearch
  },
  data() {
    return {
      showOrderTypeDialog: false,
      showServiceTypeDialog:false,
      tenant: {
        slaName: '',
        wareingValueUnit:'',
        wareingValue: 0,
        secondTime:'',
        achieveValue:'',
        achieveValueUnit:'',
        firstTime:'',
        serviceTypeNames:'',
        serviceTypeIds:'',
        orderTypeNames:'',
        orderTypeIds:'',
        companyId:'',
        entId:'',
        checkSubjectId: '',
        checkSubjectName: ''
      },
      rules: {
        slaName: [
          {required: true, prop: 'SLA名称', type: 'string',},

        ],
      },
      checkSubjectList: [],
      // 以上表单信息
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      orderTypeDialogParam: {
        usable: 1
      },
      serviceDialogParam: {
        usable: 1
      },
      dataId: '',
      timeTypeList:[
        {type:2,name: '创建时间'},
        {type:5,name: '派网点时间'},
        {type:6,name: '网点接单时间'},
        {type:9,name: '派师傅时间'},
        {type:10,name: '师傅接单时间'},
        {type:11,name: '首次预约操作时间'},
        {type:12,name: '二次预约操作时间'},
        {type:13,name: '预约时间'},
        {type:14,name: '出发时间'},
        {type:17,name: '上门时间'},
        {type:30,name: '寄修确认时间'},
        {type:31,name: '寄件时间'},
        {type:32,name: '寄件签收时间'},
        {type:36,name: '维修完成时间'},
        {type:37,name: '修好寄出时间'},
        {type:40,name: '退换确认时间'},
        {type:41,name: '旧件退回时间'},
        {type:42,name: '旧件签收时间'},
        {type:44,name: '好件寄出时间'},
        {type:47,name: '好件签收时间'},
        {type:61,name: '完工时间'},
        {type:62,name: '网点确认完工时间'},
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    // enabled: {}
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.slaSave = this.permissions["slaSave"];
  },
  mounted() {
    this.getData();
    this.loadDictData();
  },
  methods: {
    //选择产品
    selectOrderType() {
      this.showOrderTypeDialog = true;
    },
    selectServiceType() {
      this.showServiceTypeDialog = true;
    },

    commitSelectedRow(selectOrderTypeIds,selectOrderTypeNames) {
      this.tenant.orderTypeNames = selectOrderTypeNames
      this.tenant.orderTypeIds = selectOrderTypeIds
    },

    commitSelectedRowService(selectOrderTypeIds,selectOrderTypeNames) {
      this.tenant.serviceTypeNames = selectOrderTypeNames
      this.tenant.serviceTypeIds = selectOrderTypeIds
      console.log(this.tenant.serviceTypeNames)
      console.log(this.tenant.serviceTypeIds)
    },

    confirmSaleConfig(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.configGrid;
        const tableData3 = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function (item) {
          map[item.configId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            configId: row.id,
            configName: row.configName
          };
          if (index == 0 && tableData3.length == 0) {
            item.defaults = true;
          }
          if (!map[item.configId]) {
            items.push(item);
          }
        });
        this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
      }
    },
    submitUpload() {
      this.$refs.upload.submit()
    },


    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      //考核科目
      loadDictData(dictType.checkSubject).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.checkSubjectList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: api.sla.getDataUrl,
          method: 'post',
          data: {
            id: this._dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.tenant = response.data.data;
        })
      } else {
        // this.enabled = true;
      }
    },
    saveData() {
      this.$refs.tenant.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = api.sla.saveOrUpdate
            this.$http({
              url: url,
              method: `post`,
              data: this.tenant,
              isLoading: true,
            }).then(() => {
              this.$message.success("保存成功！");
              this.reload()
              this.$mask.close()

            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()

            });
            ;
          });
        }

      });

    },
    confirmCategory(rows) {
      if (rows.length > 0) {
        let row = rows[0];
        this.tenant.itemCatId = row.id;
        this.tenant.categoryName = row.categoryName;
        this.tenant.itemCatCode = row.categoryCode;
      }
    },
  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}
.table-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.table-cell {
  flex: 1;
  margin-right: 10px;
}

</style>
